import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BUSINESS, FOOTER_SMS_DISCLOSURE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#080b11]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-3">
          <div>
            <div className="font-display text-xl font-bold text-white">
              Rolling Stone Marketing
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
              The data and demand layer behind sales-driven companies.
            </p>
            <div className="mt-6 space-y-3 text-sm text-slate-400">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-amber-400 shrink-0" />
                <span data-testid="footer-address">
                  {BUSINESS.physicalAddress}
                  <br />
                  <span className="text-slate-500">
                    Mailing: {BUSINESS.mailingAddress}
                  </span>
                </span>
              </div>
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-phone"
                className="flex items-center gap-3 hover:text-amber-400 transition-colors"
              >
                <Phone size={16} className="text-amber-400 shrink-0" />
                {BUSINESS.phone}
              </a>
              <a
                href={`mailto:${BUSINESS.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 hover:text-amber-400 transition-colors"
              >
                <Mail size={16} className="text-amber-400 shrink-0" />
                {BUSINESS.email}
              </a>
            </div>
          </div>

          <div className="lg:pl-8">
            <div className="rsm-eyebrow mb-4">Navigate</div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <a href="/#services" className="hover:text-amber-400 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="/#process" className="hover:text-amber-400 transition-colors">
                  How We Work
                </a>
              </li>
              <li>
                <a href="/#contact" className="hover:text-amber-400 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy-link"
                  className="hover:text-amber-400 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms-link"
                  className="hover:text-amber-400 transition-colors"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
            <div className="mt-6 text-sm text-slate-400">
              <div className="rsm-eyebrow mb-2">Hours</div>
              {BUSINESS.hours}
            </div>
          </div>

          <div>
            <div className="rsm-eyebrow mb-4">SMS Disclosure</div>
            <p
              data-testid="footer-sms-disclosure"
              className="text-xs leading-relaxed text-slate-500"
            >
              {FOOTER_SMS_DISCLOSURE}
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} Rolling Stone Marketing. All rights reserved.
          </p>
          <p className="text-xs text-slate-600 font-mono">
            {BUSINESS.domain}
          </p>
        </div>
      </div>
    </footer>
  );
}
